import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { alert } from 'devextreme/ui/dialog';
import { ToolbarComponent } from '../../toolbar/toolbar.component';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { Apiservice } from '../../../services/api.service';
import { Utenteservice } from '../../../services/utente.service';



@Component({
  selector: 'app-crm-email-editor',
  templateUrl: './crmEmailEditor.component.html',
  styleUrls: ['./crmEmailEditor.component.css']
})
export class CrmEmailEditorComponent implements OnInit, AfterViewInit {
  @ViewChild('menuBottom', { static: false }) menuBottom: ToolbarComponent;
  @ViewChild('dataGridAllegati', { static: false }) dataGridAllegati: NicaAnagraficaComponent;
  @Input() valueContent: string = '';
  @Input() idContatto
  @Input() queryString
  @Input() obj: any;
  popupLocVisible: boolean;
  popupFileListVisible: boolean;
  uploadedFilesLocal: File[] = [];
  filesList: any[] = [];
  selectedFilesList: any[] = [];
  standardBtnBottom: any = [13, 0];
  standardBtnLoc: any = [0];
  standardBtnList: any = [22];
  inputValueTagA: any[] = []
  inputValueTagCc: any[] = []
  inputOggettoValue: string = ''
  inputNoteValue: string = ''
  inputDaValue: string = 'info@winwaste.it'
  maxDisplayedTags = 5
  validationStatusTagA = 'invalid'
  emailsValideList = new DataSource({
    store: {
      data: [],
      type: 'array',
      key: 'Cod',
    },
    group: 'SedeDesc',
  });
  allegaLocBtnOptions = {
    text: 'Allega Locale',
    icon: 'activefolder',
    stylingMode: 'contain',
    onClick: () => {
      const inputFile = document.createElement('input') as HTMLInputElement;
      inputFile.type = 'file';
      inputFile.multiple = true;
      inputFile.style.display = 'none';
      inputFile.click()
      inputFile.addEventListener('change', (event: any) => {
        Array.from(event.target.files).forEach((file: any) => {
          if (!this.uploadedFilesLocal.some(f => f.name === file.name)) {
            this.uploadedFilesLocal.push(file);
          }
        });
      });

    },
  };
  allegaListBtnOptions = {
    text: 'Allega Contatto',
    icon: 'movetofolder',
    stylingMode: 'contain',
    onClick: () => {
      this.popupFileListVisible = true
    },
  };
  svuotaBtnOptions = {
    text: 'Cancella',
    icon: 'clearformat',
    stylingMode: 'text',
    selectedItemKey: '',
    keyExpr: "id",
    displayExpr: "name",
    useSelectMode: false,
    items: [
      {
        "id": 1,
        "name": "Contenuto",
        "icon": "doesnotcontain",
        "hint": 'Svuota contenuto'
      },
      {
        "id": 2,
        "name": "Allegati",
        "icon": "file",
        "hint": 'Svuota Allegati'
      },
    ],
    onItemClick: ($event) => {
      if ($event.itemData && $event.itemData.name) {
        switch ($event.itemData.name) {
          case 'Contenuto':
            return this.valueContent = ''
          case 'Allegati':
            this.filesList = []
            this.uploadedFilesLocal = []
            return
          default:
            return
        }
      }
    }

  };
  constructor(private userComponentService: ComponentService, private cdr: ChangeDetectorRef, private api: Apiservice, private utenteSerivce: Utenteservice) { }
  ngAfterViewInit(): void {

  }
  ngOnInit(): void {
    console.log('stampo data in ingresso this.obj', this.obj);
    let newObj = this.obj
    if (newObj) this.estraiContattiConSede(newObj).forEach((item) => {
      this.emailsValideList.store().insert(item).then(() => this.emailsValideList.load())
    })
    if (this.queryString === undefined && this.idContatto !== undefined) this.queryString = `?nomeTabella=CRM_CONTATTI&idTabella=${this.idContatto}`;
  }
  estraiContattiConSede(data: any[]): any[] {
    const risultato: any[] = [];
    const regexp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
    data.forEach(item => {
      const sedeDesc = `${item.sede.Ind || 'Sede Legale'}`;
      item.contatti.forEach(contatto => {
        if (contatto.Sede === 0) {
          risultato.unshift({
            disabled: !regexp.test(contatto.Mail),
            ...contatto,
            SedeDesc: sedeDesc
          });
        } else {
          risultato.push({
            disabled: !regexp.test(contatto.Mail),
            ...contatto,
            SedeDesc: sedeDesc
          });
        }
      });
    });

    return risultato;
  }
  onValueChanged(event, tipo: string) {
    if (tipo === 'inputValueTagA') {
      if (event.value.length > 0) {
        this.validationStatusTagA = 'valid'
      } else {
        this.validationStatusTagA = 'invalid'
      }
    }
    return
  }
  onRowSelectionChanged(event) {
    if (event.currentDeselectedRowKeys && event.currentDeselectedRowKeys.length > 0) {
      const deselectedIds = new Set(event.currentDeselectedRowKeys);
      this.selectedFilesList = this.selectedFilesList.filter(obj => !deselectedIds.has(obj.id));
    }
    if (event.selectedRowsData && event.selectedRowsData.length > 0) {
      const selectedIds = new Set(this.selectedFilesList.map(f => f.id));
      const newSelections = event.selectedRowsData.filter(row => !selectedIds.has(row.id));
      this.selectedFilesList = this.selectedFilesList.concat(newSelections);
    }
  }

  removeFile(index: number, e) {
    if (e.element && e.element.name) {
      switch (e.element.name) {
        case "eliminaFileLocal":
        case 'eliminaFileAllegatoLocal':
          this.uploadedFilesLocal.splice(index, 1);
          return
        default:
          return
      }
    }
    return

  }
  onCustomItemCreating(e) {
    const regexp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
    const newValue = e.text.trim();
    if (!newValue) {
      e.customItem = false
      return false;
    }
    if (!regexp.test(newValue)) {
      e.customItem = false
      return false
    }
    // Controlla se l'email esiste già
    // Cerchiamo l'elemento tra tutti gli items raggruppati
    const groupedItems = this.emailsValideList.items();
    let allItems = [];

    for (const group of groupedItems) {
      if (Array.isArray(group.items)) {
        allItems = allItems.concat(group.items);
      }
    }

    const existingItem = allItems.find(item => item.Mail === newValue);

    if (existingItem) {
      e.customItem = existingItem;
      return;
    }
    // Crea un nuovo Cod incrementale
    const productIds = allItems.length > 0 ? allItems.map((item) => item.Cod) : [0];
    const incrementedId = Math.max.apply(null, productIds) + 1;
    const newItem = { Mail: newValue, Cod: incrementedId, SedeDesc: 'Altri' };
    // Inserisce l'elemento nello store e lo ritorna asincronamente
    e.customItem = this.emailsValideList.store().insert(newItem)
      .then(() => this.emailsValideList.load())
      .then(() => newItem)
  }

  removeFileList(file, index) {
    this.filesList.splice(index, 1);
    this.dataGridAllegati.selectedKeys = this.dataGridAllegati.selectedKeys.filter(n => n !== file.id);
  }
  removeAll(e) {
    if (e.element && e.element.name)
      switch (e.element.name) {
        case 'svuotaList':
          this.selectedFilesList = []
          return
        default:
          return
      }

  }
  emettiChiusuraListFile() {
    this.popupFileListVisible = false
    this.dataGridAllegati.griglia.instance.deselectAll()
    this.filesList.forEach(element => {
      this.dataGridAllegati.griglia.instance.selectRows(element.id, true)
    });
  }
  maxStringsVisualizzabili(arr, maxCharTotali) {
    let somma = 0;
    let count = 0;
    for (const str of arr) {
      const len = str.length;
      if (somma + len > maxCharTotali) {
        break;
      }
      somma += len;
      count++;
    }
    return count;
  }
  toolbarBottomEmitted(e, typeBtn) {
    switch (typeBtn) {
      case 'standardBtnBottom':
        if (e == 13) {
          this.inviaEmail()
        } else {
          this.userComponentService.destroyCurrentOpenPopUp('CrmEmailEditorComponent')
        }
        return
      case 'standardBtnLoc':
        this.popupLocVisible = false;
        return
      case 'standardBtnList':
        if (e == 22) {
          this.filesList = this.selectedFilesList
          this.popupFileListVisible = false;
        }
        return
      default:
        return
    }
  }

  async inviaEmail() {
    const formData = new FormData();
    if (this.idContatto) formData.append('CodContatto', this.idContatto)
    formData.append('da', this.inputDaValue);
    if (this.inputValueTagA.length > 0) {
      formData.append('a', this.inputValueTagA.join(';'));
    } else {
      alert('Inserire uno o più destinatari', 'Attenzione')
      return false
    }
    if (this.inputValueTagCc.length > 0) {
      formData.append('cc', this.inputValueTagCc.join(';'));
    }
    formData.append('oggetto', this.inputOggettoValue);
    if (this.valueContent && this.valueContent !== '') {
      formData.append('body', this.valueContent);
    } else {
      alert('Inserisci un contenuto', 'Attenzione')
      return false
    }
    if (this.uploadedFilesLocal.length > 0) {
      this.uploadedFilesLocal.forEach((file, i) => {
        formData.append('files[]', file);
      })
    }
    if (this.filesList.length > 0) {
      formData.append('allegatiContatto', JSON.stringify(this.filesList));
    }
    return await this.api.PostApiRest('inviaemail', formData).then((res: { [key: string]: any }) => {
      if (res.code && res.code === 0) {
        return this.salvaEmailInviata()
      } else {
        alert(res.message, 'Errore')
      }
    })
  }
  async salvaEmailInviata() {
    const formData = new FormData();
    const moment = require('moment')
    formData.append('CodContatto', this.idContatto)
    formData.append('mittente', this.inputDaValue);
    formData.append('destinatari', this.inputValueTagA.join(';'));
    formData.append('in_copia', this.inputValueTagCc.join(';'));
    formData.append('oggetto', this.inputOggettoValue);
    formData.append('contenuto', this.valueContent);
    formData.append('data_invio', moment());
    if (this.inputNoteValue) {
      formData.append('note', this.inputNoteValue);
    }
    const utenteLoggato = this.utenteSerivce.InfoDatiUtenteConnesso.nomeCompleto || ''
    formData.append('utente', utenteLoggato)
    return await this.api.PostApiRest('elencoemail', formData).then((res: { [key: string]: any }) => {
      if (res.code && res.code === 0) {
        console.log(res)
      } else {
        alert(res.message, 'Errore')
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  // ! --------------------------------------------------------------------------------------------------------------
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = input.files
      Array.from(files).forEach(file => {
        if (!this.uploadedFilesLocal.some(f => f.name === file.name)) {
          this.uploadedFilesLocal.push(file);
        }
      });
    }
  }
  onFileDropped(files: FileList) {
    Array.from(files).forEach(file => {
      if (!this.uploadedFilesLocal.some(f => f.name === file.name)) {
        this.uploadedFilesLocal.push(file);
      }
    });
  }
}


